import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import MediaHolder from "./MediaHolder";
import { deleteProductMedia,  addProductMedia} from "helpers/API Calls/Operations/Products";

export interface MediaItem {
  id: number;
  file_type: "image" | "video";
  file_name: string | null;
  file_url: string | null;
  is_featured?: 1 | 0;
}

interface ImageGalleryProps {
  files: MediaItem[];
  productId: number;
  req_type: 'product' | 'package', 
}

function ImageGallery({ files, productId, req_type }: ImageGalleryProps) {

  const [mediaItems, setMediaItems] = useState<MediaItem[]>([]);
  const [loadingMediaId, setLoadingMediaId] = useState<number | null>(null);

  // Ensure at least one empty slot is always present
  useEffect(() => {
    if (files.length > 0) {
      const newFiles = [...files];
      // Ensure there is one empty slot at the end
      if (newFiles[newFiles.length - 1].file_name !== null) {
        newFiles.push({ id: newFiles.length + 1, file_type: "image", file_name: null, file_url: null });
      }
      setMediaItems(newFiles);
    } else {
      // If no files, ensure there's at least one empty slot
      setMediaItems([{ id: 0, file_type: "image", file_name: null, file_url: null }]);
    }
  }, [files]);

  const handleMediaUpload = async (index: number, file : File, file_name: string | null, file_url: string | null, type: "image" | "video") => {
    setLoadingMediaId(index);
    const newMediaItems = [...mediaItems];
    newMediaItems[index] = { id: index, file_name, file_url, file_type : type, is_featured: 0 };
    setMediaItems(newMediaItems);
    if (newMediaItems[newMediaItems.length - 1]?.file_name !== null) {
      newMediaItems.push({ id: newMediaItems.length, file_type: "image", file_name: null, file_url: null });
    }

    const response = await addProductMedia({image : file, is_featured: 0, type: req_type}, productId);
    setLoadingMediaId(null);
    if (!response?.success) {
      setMediaItems(mediaItems)
    }else{
      newMediaItems[index].id = response?.data?.id; 
      setMediaItems(newMediaItems);
    }
  };

  const handleDeleteMedia = async (id: number) => {
    setLoadingMediaId(id);
    const response = await deleteProductMedia(id);
    setLoadingMediaId(null);
  
    if (response.success) {
      const newMediaItems = mediaItems.filter((media) => media.id !== id);
      
      // Check if there's no media items left after deletion
      if (newMediaItems.length === 0) {
        // If all media is deleted, ensure at least one empty slot
        setMediaItems([{ id: 0, file_type: "image", file_name: null, file_url: null }]);
      } else {
        // If there are other media items, just update the state without adding an empty slot
        setMediaItems(newMediaItems);
      }
    }
  };

  const handleUpdateFeatureImg = (id: number) => {
    setMediaItems((prevMediaItems) =>
      prevMediaItems.map((item) =>
        item.id === id ? { ...item, is_featured: 1} : {...item, is_featured: 0}
      )
    );
  };

  return (
    <Col style={{ maxWidth: "fit-content" }}>
      <Row className="flex-nowrap justify-content-start">
        {mediaItems.map((media, index) => (
          <MediaHolder
            key={media.id}
            media={media}
            onMediaUpload={(fileData:File, type) => handleMediaUpload(index, fileData, fileData?.name, URL.createObjectURL(fileData), type)}
            onDeleteMedia={() => handleDeleteMedia(media.id)}
            onSave={handleUpdateFeatureImg}
            loading={loadingMediaId === (media.id)}
            productId={productId}
          />
        ))}
      </Row>
    </Col>
  );
}

export default ImageGallery;
